import { useEffect, useMemo, useState } from 'react';

/** Client-side pagination for master lists that are fetched in full. */
export function useClientPagination(rows = [], initialLimit = 50) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(initialLimit);
  const total = rows.length;
  const totalPages = Math.max(1, Math.ceil(total / limit));

  useEffect(() => {
    setPage(1);
  }, [total, limit]);

  const pageRows = useMemo(
    () => rows.slice((page - 1) * limit, page * limit),
    [rows, page, limit]
  );

  return { page, setPage, limit, setLimit, total, totalPages, pageRows };
}

export default useClientPagination;
